export const PropertyPlanEnum = {
  lookupTypeId: 49,
};
